class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.bindSubmenuClicks();
  }

  bindSubmenuClicks() {
		const closeLevel2AndDescendants = (level2Item) => {
			level2Item.querySelectorAll('.ec-level-3-item.is-open').forEach((level3Open) => {
				level3Open.classList.remove('is-open')
				const w = level3Open.querySelector('.ec-level-4-wrapper')
				if (w) w.classList.remove('is-open')
				const t = level3Open.querySelector('.ec-level-3-trigger')
				if (t) t.setAttribute('aria-expanded', 'false')
			})
			level2Item.classList.remove('is-open')
			const t = level2Item.querySelector('.ec-level-2-trigger')
			if (t) t.setAttribute('aria-expanded', 'false')
		}

		const handleLevel2Trigger = (trigger) => {
			const item = trigger.closest('.ec-level-2-item')
			if (!item) return
			this.querySelectorAll('.ec-level-2-item.is-open').forEach((open) => {
				if (open !== item) closeLevel2AndDescendants(open)
			})
			item.classList.toggle('is-open')
			trigger.setAttribute('aria-expanded', item.classList.contains('is-open'))
			if (!item.classList.contains('is-open')) closeLevel2AndDescendants(item)
		}

		const handleLevel3Trigger = (trigger) => {
			const item = trigger.closest('.ec-level-3-item')
			if (!item) return
			const level3 = item.closest('.ec-level-3')
			if (level3) {
				level3.querySelectorAll('.ec-level-3-item.is-open').forEach((open) => {
					if (open !== item) {
						open.classList.remove('is-open')
						const w = open.querySelector('.ec-level-4-wrapper')
						if (w) w.classList.remove('is-open')
						const t = open.querySelector('.ec-level-3-trigger')
						if (t) t.setAttribute('aria-expanded', 'false')
					}
				})
			}
			item.classList.toggle('is-open')
			trigger.setAttribute('aria-expanded', item.classList.contains('is-open'))
			const wrapper = item.querySelector('.ec-level-4-wrapper')
			if (wrapper) {
				wrapper.classList.toggle('is-open', item.classList.contains('is-open'))
			}
		}

    this.querySelectorAll('.ec-level-2-trigger').forEach((trigger) => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        handleLevel2Trigger(trigger);
      });
      trigger.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleLevel2Trigger(trigger);
        }
      });
    });

    this.querySelectorAll('.ec-level-3-trigger').forEach((trigger) => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        handleLevel3Trigger(trigger);
      });
      trigger.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleLevel3Trigger(trigger);
        }
      });
    });

    document.addEventListener('click', (e) => {
      if (!this.contains(e.target)) {
        this.querySelectorAll('.ec-level-2-item.is-open').forEach((el) => closeLevel2AndDescendants(el));
        this.querySelectorAll('.ec-level-3-item.is-open').forEach((el) => {
          el.classList.remove('is-open');
          const w = el.querySelector('.ec-level-4-wrapper');
          if (w) { w.classList.remove('is-open'); }
          const t = el.querySelector('.ec-level-3-trigger');
          if (t) t.setAttribute('aria-expanded', 'false');
        });
      }
    });
  }

  closeAllSubmenus() {
    this.querySelectorAll('.ec-level-2-item.is-open').forEach((el) => {
      el.querySelectorAll('.ec-level-3-item.is-open').forEach((level3) => {
        level3.classList.remove('is-open');
        const w = level3.querySelector('.ec-level-4-wrapper');
        if (w) w.classList.remove('is-open');
        const t = level3.querySelector('.ec-level-3-trigger');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
      el.classList.remove('is-open');
      const t = el.querySelector('.ec-level-2-trigger');
      if (t) t.setAttribute('aria-expanded', 'false');
    });
  }

  onToggle() {
    if (!this.mainDetailsToggle.hasAttribute('open')) this.closeAllSubmenus();
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
